"use client";

// Removed react-query imports
import {
  ChevronDown,
  Contact2,
  CreditCard,
  Mail,
  Plus,
  SlidersHorizontal,
  User,
  Users,
} from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { Input } from "@/components/ui/input";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { UserWithCompanies } from "@/components/auth";
import { useAppStore, selectUser, AppStoreState } from "@/store/appStore";
console.log("SpaceSelector useAppStore instance", useAppStore);
import { FC, useRef, useState } from "react";
import { useSpaceSettingsDialog } from "../space-settings-dialog/useSpaceSettingsDialog";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Company } from "@prisma/client";
import clsx from "clsx";

export const createCompany = async (
  companyName: string
): Promise<Response | string> => {
  console.log("Create Company", companyName);
  if (companyName) {
    const response = await fetch("/api/company/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: companyName }),
    });
    return await response.json();
  } else {
    return "Company name is required";
  }
};

export const switchCompany = (companyId: string): Promise<Response> => {
  console.log("Switch Company", companyId);
  // update database over rest api
  return fetch("/api/company/switch", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ companyId: companyId }),
  }).then(async (response) => {
    return response;
  });
};

const SpaceSelector: FC = () => {
  // Zustand user selector
  const companies = useAppStore((s: AppStoreState) => s.companies);
  const setCompanies = useAppStore((s: AppStoreState) => s.setCompanies);
  console.log("SpaceSelector setCompanies ref", setCompanies);
  const selectedCompany = useAppStore((s: AppStoreState) => s.selectedCompany);
  const projectNameInputRef = useRef<HTMLInputElement>(null);
  const [open, setOpen] = useState(false);

  console.log("SpaceSelector companies", companies);

  // Removed user variable; using companies from store

  // Remove mutation/queryClient logic, will use zustand action

  const onCompanyCreate = () => {
    console.log("Create Company");
    if (projectNameInputRef.current) {
      createCompany(projectNameInputRef.current?.value);
      projectNameInputRef.current.value = "";
    }
  };

  const setSelectedCompany = useAppStore(
    (s: AppStoreState) => s.setSelectedCompany
  );
  const onSwitchCompany = async (companyId: string) => {
    const response = await switchCompany(companyId);
    const body = await response.json();
    if (body.company) {
      setSelectedCompany(body.company);
      // If you need to fetch more data, do it here
    }
  };

  const { openDialog, Dialog: SpaceSettingsDialogModal } =
    useSpaceSettingsDialog();

  return (
    <>
      {SpaceSettingsDialogModal}
      <Dialog>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create New Space</DialogTitle>
          </DialogHeader>
          <Input ref={projectNameInputRef} placeholder="Space name..."></Input>
          <Button onClick={onCompanyCreate}>Create Space</Button>
        </DialogContent>
        <div className="pt-md p-sm">
          {/** Company Picker **/}
          <DropdownMenu modal={false} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild className="w-full">
              <Button
                variant={"ghost"}
                className={"w-full justify-start !p-sm !py-[25px] flex "}
              >
                <div className="flex flex-row align-middle items-center space-x-sm">
                  <Avatar className="project-icon bg-foreground/5 rounded-sm">
                    <AvatarFallback>
                      {selectedCompany?.name?.charAt(0)}
                    </AvatarFallback>
                  </Avatar>
                  <div className="project-name text-foreground ">
                    {selectedCompany ? selectedCompany.name : "No Company"}
                  </div>
                </div>
                <div className={"text-foreground ml-auto "}>
                  <ChevronDown
                    className={clsx(
                      "size-4 transition-all",
                      open && "rotate-180"
                    )}
                  />
                </div>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="start"
              className={"mr-2 w-[--radix-dropdown-menu-trigger-width]"}
            >
              <DropdownMenuLabel>{selectedCompany?.name}</DropdownMenuLabel>

              <DropdownMenuItem onClick={() => openDialog("profile")}>
                <Contact2 /> Profile
              </DropdownMenuItem>

              <DropdownMenuItem onClick={() => openDialog("billing")} disabled>
                <CreditCard /> Billing
              </DropdownMenuItem>

              <DropdownMenuItem onClick={() => openDialog("team")} disabled>
                <Users /> Team
              </DropdownMenuItem>

              <DropdownMenuItem>
                <Mail /> Notifications
              </DropdownMenuItem>

              <DropdownMenuSeparator />
              <DropdownMenuLabel>Spaces</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {companies?.length ? (
                companies.map((company: Company, index: number) => {
                  return (
                    <DropdownMenuItem
                      key={index}
                      className={
                        selectedCompany?.id === company.id
                          ? "active-project"
                          : ""
                      }
                      onClick={() => onSwitchCompany(company.id)}
                    >
                      <Avatar className="project-icon bg-foreground/5">
                        <AvatarFallback className="bg-foreground/5">
                          {company.name.charAt(0)}
                        </AvatarFallback>
                      </Avatar>
                      {company.name}
                    </DropdownMenuItem>
                  );
                })
              ) : (
                <small className="p-2 brightness-50">
                  Create a space to get started.
                </small>
              )}

              <DropdownMenuSeparator />
              <DialogTrigger style={{ width: "100%" }}>
                <DropdownMenuItem>
                  <Plus className=" mr-1 inline" />
                  <span className="pt-0.5 inline-block">Create New Space</span>
                </DropdownMenuItem>
              </DialogTrigger>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </Dialog>
    </>
  );
};

export { SpaceSelector };
